import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { postponeViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getPostponeViewInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getViewInfo, param);

    if (data.data === null) {
      yield put(postponeViewAction.loadPostponeViewSuccess(false));
    } else {
      yield put(postponeViewAction.loadPostponeViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(postponeViewAction.loadPostponeViewFail(error));
    yield put(globalFinishLoading());
  }
}
